import { Box, Button, Divider, Typography } from '@mui/material';
import React from 'react';

import { IStoryListMessages } from '../../../../types';

import { styles } from './PageHeader.styles';

export interface IPageHeaderProps {
  isOrganizeStoriesInProgress: boolean;
  messages: IStoryListMessages;
  entitySubdomain: string;
  folderId: string;
  isOrganizeFromPublication?: boolean;
  isReorderRootSectionsActive?: boolean;
  pushToFolderList?(entitySubdomain: string, folderId: string): void;
  navigateToSection?(): void;
}

export const PageHeader: React.FC<IPageHeaderProps> = ({
  messages,
  isOrganizeStoriesInProgress,
  isReorderRootSectionsActive,
  entitySubdomain,
  folderId,
  isOrganizeFromPublication = false,
  pushToFolderList,
  navigateToSection
}) => {
  return (
    <div>
      <Box sx={styles.header}>
        <Box sx={styles.headerContent}>
          <Typography variant="h2" component="h2" data-test="organize-stories-folders-title">
            {isOrganizeFromPublication ? messages.organizePdf : messages.organizeStoriesAndFolders}
          </Typography>
          <Box sx={styles.buttons}>
            <Button
              disabled={isOrganizeStoriesInProgress || isReorderRootSectionsActive}
              data-test="done-organize-stories-button"
              variant="contained"
              size="small"
              onClick={() => {
                if (!isOrganizeFromPublication) {
                  pushToFolderList(entitySubdomain, folderId);
                } else {
                  navigateToSection();
                }
              }}
            >
              {messages.done}
            </Button>
          </Box>
        </Box>
      </Box>
      <Divider data-test="divider" />
    </div>
  );
};
